import { render, staticRenderFns } from "./appraisalResult.vue?vue&type=template&id=16fb68fa&scoped=true&"
import script from "./appraisalResult.vue?vue&type=script&lang=js&"
export * from "./appraisalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fb68fa",
  null
  
)

export default component.exports